import React, { useState } from "react";
import { CircularProgress, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { Autocomplete } from "@material-ui/lab";
import Dropdown from "rc-dropdown";
import DefaultButton from "../../../styles/materialButtonStyle";
import {
  StyledFilterBlock, StyledFilterBlockTitle,
  StyledFilterCloseBtn, StyledFilterDropdownWrapper,
  StyledFilterGroup, StyledFilterWrapper, StyledSelectGroup, StyledShowFilterBtn,
} from "../../../elements/filter/styledFiter";

const TelegramDrainWalletsFilter = ({ filterData, setFilterData, bots, botsLoading, onOpen, t }) => {
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (val) => {
    setVisible(val);
    if (val) onOpen();
  };

  const FilterList = () => (
    <>
      {visible && (
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton color="transparent" onClick={() => setFilterData(prev => ({ ...prev, projectId: null }))}>
                {t("drainWallets.filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>

          <StyledFilterBlockTitle>{t("drainWallets.filter.filterBy")}:</StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledSelectGroup>
              <FormControl>
                <Autocomplete
                  options={bots}
                  loading={botsLoading}
                  value={bots.find(b => String(b.projectId) === String(filterData.projectId)) || null}
                  onChange={(e, val) => setFilterData(prev => ({ ...prev, projectId: val ? String(val.projectId) : null }))}
                  getOptionLabel={(option) => option.projectName}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t("bots.table.project")}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {botsLoading ? <CircularProgress color="inherit" size={16} /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                  blurOnSelect
                />
              </FormControl>
            </StyledSelectGroup>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>
      )}
    </>
  );

  return (
    <StyledFilterWrapper id="tg-drain-wallets-filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("tg-drain-wallets-filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={handleVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton color="success">
            {t("drainWallets.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default TelegramDrainWalletsFilter;
